module.exports = __webpack_public_path__ + "static/media/trybewarts.74e9266c.mp4";